import { isNil } from 'lodash';
import React, { AnchorHTMLAttributes } from 'react';
import {
  SpaceProps,
  alignSelf,
  color,
  fontFamily,
  fontSize,
  fontWeight,
  height,
  justifySelf,
  space,
  textAlign,
  width,
} from 'styled-system';
import {
  ColoringProps,
  SelfPositioningProps,
  SizingProps,
  TypographyProps,
} from '~frontend-common/lib/styled-components';
import { styled } from '~ui-kit/styled-components';
import { theme } from '~ui-kit/theme';

export interface ExternalLinkProps
  extends SpaceProps,
    ColoringProps,
    TypographyProps,
    SelfPositioningProps,
    SizingProps,
    AnchorHTMLAttributes<HTMLAnchorElement> {
  color?: string;
  colorHover?: string;
  to?: string;
  openNewTab?: boolean;
}

export const ExternalLink = React.forwardRef<HTMLAnchorElement, ExternalLinkProps>(function ExternalLink(
  {
    to,
    href,
    openNewTab = true,
    children,
    color = theme.colors.link,
    colorHover = theme.colors.linkHover,
    ...rest
  }: ExternalLinkProps,
  ref,
) {
  return isNil(to) && isNil(href) ? (
    <span {...rest}>{children}</span>
  ) : (
    <StyledExternalLink
      href={to || href}
      target={openNewTab ? '_blank' : undefined}
      color={color}
      $colorHover={colorHover}
      ref={ref}
      {...rest}
    >
      {children}
    </StyledExternalLink>
  );
});

const StyledExternalLink = styled.a<{ $colorHover?: string }>`
  ${fontSize};
  ${space};
  ${color};
  ${fontWeight};
  ${textAlign};
  ${fontFamily};
  ${alignSelf};
  ${justifySelf};
  ${height};
  ${width};

  display: inline;
  &:hover {
    color: ${(props) => props.$colorHover};
  }
`;
